import type { RichTextData } from '~/utils/crystallize/component-schemas'

export function blocksHaveContent(blocks: RichTextData | undefined | null): blocks is RichTextData {
  return !!blocks?.some(blockHasContent)
}

export function blockHasContent(block: RichTextData[number]) {
  return !!block.textContent?.trim() || !!block.children?.some(blockHasContent)
}

export function getTextContent(blocks: RichTextData | undefined | null) {
  function extractText(block: RichTextData[number]): string {
    let text = block.textContent?.trim() || ''
    if (block.children) {
      for (const child of block.children) {
        text += ` ${extractText(child)}`
      }
    }
    return text
  }

  return blocks?.map(extractText).join(' ').trim()
}
